module.exports = __webpack_public_path__ + "static/eagle-labs-9b7ed968a8f820dc96a9e73e9fca8eef.png";